import React from 'react';
import { Button, Checkbox } from 'antd';
import { changeImageSize, createLiveChat, formatNumber, getData, setDefaultImage } from '../utils';
import {
    addOrRemoveFromComparison,
    addOrRemoveFromWishList,
    addToCart,
    updateCart,
} from '../reducer';
import WishListButton from './WishListButton';
import NumberInput from './NumberInput';
import '../css/ProductCard.less';
import loadable from '@loadable/component';

import { ReactComponent as ShoppingCart } from '../icons/material/shopping_cart_black_24dp.svg';
import { ReactComponent as ShoppingCartSharp } from '../icons/material/shopping_cart_black_24dp_sharp.svg';
import QuantityCircle from './QuantityCircle';

const UpsellModal = loadable(() => import(/* webpackChunkName: "UpsellModal" */ './UpsellModal'));

class ProductCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOnWishList: this.props.isOnWishList,
            isInComparison: this.props.isInComparison,
            discountPrice: this.props.discountPrice,
            hover: false,
            cardStyle: this.props.cardStyle,
            discount: null,
            quantityInCart: this.props.quantityInCart,
            basketId: this.props.basketId,
            insurancesAvailable: [],
            insuranceModalOpen: false,
        };

        this.hoverOn = this.hoverOn.bind(this);
        this.hoverOff = this.hoverOff.bind(this);
    }

    componentDidMount() {
        if (this.props.discountPrice) {
            this.setState({
                discount: this.props.discountPrice
                    ? ((this.props.price - this.props.discountPrice) / this.props.price) * 100
                    : null,
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.cardStyle !== this.props.cardStyle) {
            this.setState({ cardStyle: this.props.cardStyle });
        }
        if (prevProps.isOnWishList !== this.props.isOnWishList) {
            this.setState({ isOnWishList: this.props.isOnWishList });
        }
        if (prevProps.isInComparison !== this.props.isInComparison) {
            this.setState({ isInComparison: this.props.isInComparison });
        }
        if (prevProps.quantityInCart !== this.props.quantityInCart)
            this.setState({
                basketId: this.props.basketId,
                quantityInCart: this.props.quantityInCart,
            });
        let discount = this.props.discountPrice
            ? ((this.props.price - this.props.discountPrice) / this.props.price) * 100
            : null;
        if (discount !== this.state.discount) this.setState({ discount: discount });
    }

    hoverOn() {
        this.setState({ hover: true });
    }
    hoverOff() {
        this.setState({ hover: false });
    }

    updateWishList = (e, id) => {
        this.props.store.dispatch(addOrRemoveFromWishList(e, id));
        this.setState({ isOnWishList: !this.state.isOnWishList });
    };

    openChat = (e) => {
        e.preventDefault();
        e.stopPropagation();
        createLiveChat(2);
        return false;
    };

    addProductToCart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.store.dispatch(
            addToCart(
                this.props.id,
                1,
                e,
                this.props.title,
                this.props.discountPrice ? this.props.discountPrice : this.props.price
            )
        );
        getData('FetchAvailableInsurances', {
            productId: this.props.id,
        }).then((res) => {
            this.setState({
                insurancesAvailable: res.insurancesAvailable,
            });
            if (res.insurancesAvailable.length > 0) this.setState({ insuranceModalOpen: true });
        });
        return false;
    };

    updateComparison = (e, id) => {
        this.props.store.dispatch(addOrRemoveFromComparison(e, id));
    };

    updateCart = (e, quantity) => {
        this.props.store.dispatch(updateCart(e, this.props.id, this.state.basketId, quantity));
    };

    renderButtonsOrigo = (specialOrder) => {
        return specialOrder ? (
            this.state.cardStyle === 'mobile' ? (
                <Button
                    onClick={(e) => this.openChat(e)}
                    className={'origo-button'}
                    aria-label={process.env.REACT_APP_SPECIAL_ORDER_TEXT}
                >
                    <i className="material-icons">contact_support</i>
                </Button>
            ) : (
                <Button onClick={(e) => this.openChat(e)} className={'origo-button'}>
                    {process.env.REACT_APP_SPECIAL_ORDER_TEXT}
                </Button>
            )
        ) : this.props.quantity > 0 ? (
            this.state.cardStyle === 'mobile' ? (
                <Button
                    onClick={this.addProductToCart}
                    className={'origo-button'}
                    aria-label={'Bæta í körfu'}
                >
                    <ShoppingCart height={24} />
                </Button>
            ) : this.state.quantityInCart === 0 ? (
                <Button onClick={this.addProductToCart} className={'origo-button'}>
                    Bæta í körfu
                </Button>
            ) : (
                <NumberInput quantity={this.state.quantityInCart} updateCart={this.updateCart} />
            )
        ) : this.props.reykjavik > 0 ? (
            <div className={'status'}>Til í verslun</div>
        ) : this.props.expected ? (
            <div className={'status expected'}>Væntanlegt</div>
        ) : (
            <div className={'status sold-out'}>Uppselt</div>
        );
    };

    renderButtonsTolvutek = () => {
        let productAvailable =
            this.props.quantity > 0 || this.props.reykjavik > 0 || this.props.akureyri > 0;
        return this.props.specialOrder && !productAvailable ? (
            <Button onClick={(e) => this.openChat(e)} className={'origo-button specialorder'}>
                {process.env.REACT_APP_SPECIAL_ORDER_TEXT}
            </Button>
        ) : productAvailable ? (
            this.state.cardStyle === 'mobile' ? (
                <Button
                    onClick={this.addProductToCart}
                    className={'origo-button'}
                    aria-label={'Bæta í körfu'}
                >
                    <ShoppingCartSharp height={24} />
                </Button>
            ) : this.state.quantityInCart === 0 ? (
                <Button onClick={this.addProductToCart} className={'origo-button'}>
                    Bæta í körfu
                </Button>
            ) : (
                <NumberInput quantity={this.state.quantityInCart} updateCart={this.updateCart} />
            )
        ) : this.props.expected ? (
            <Button onClick={this.addProductToCart} className={'origo-button preorder'}>
                Forpanta
            </Button>
        ) : (
            <div className={'status sold-out'}>Uppselt</div>
        );
    };

    hideInsuranceModal = () => {
        this.setState({
            insuranceModalOpen: false,
        });
    };

    isSpecialOrder = () => {
        if (process.env.REACT_APP_STORE === 'tolvutek') {
            return this.props.specialOrder;
        } else {
            return (
                this.props.specialOrder === 'SpecialOrder' ||
                (this.props.specialOrder === 'SpecialOrderWithPrice' && this.props.quantity <= 0)
            );
        }
    };

    getPrices = () => {
        return (
            <div className={'prices'}>
                {this.props.specialOrder === 'SpecialOrder' &&
                process.env.REACT_APP_STORE !== 'tolvutek' ? (
                    <div className={'price'}>Sérpöntunarvara</div>
                ) : (
                    <div>
                        {this.props.discountPrice && this.props.discountPrice < this.props.price ? (
                            <div>
                                <div className={'discount-price'}>
                                    {formatNumber(this.props.discountPrice)}
                                </div>
                                <div className={'list-price'}>{formatNumber(this.props.price)}</div>
                            </div>
                        ) : (
                            <div className={'price'}>{formatNumber(this.props.price)}</div>
                        )}
                        {this.state.discount && Math.round(this.state.discount) > 0 ? (
                            <div className={'discount'}>-{Math.round(this.state.discount)}%</div>
                        ) : (
                            ''
                        )}
                    </div>
                )}
            </div>
        );
    };

    getButtons = (specialOrder) => {
        return (
            <div className={'buttons'}>
                <WishListButton
                    id={this.props.id}
                    updateWishList={this.updateWishList}
                    isOnWishList={this.state.isOnWishList}
                    className={'add-to-wishList'}
                />
                {process.env.REACT_APP_STORE === 'tolvutek'
                    ? this.renderButtonsTolvutek()
                    : this.renderButtonsOrigo(specialOrder)}
            </div>
        );
    };

    render() {
        let availableQuantity = this.props.quantity;
        const specialOrder = this.isSpecialOrder();
        let url = this.props.baseUrl ? this.props.baseUrl : '';
        url += '/SelectProd?prodId=' + this.props.id;
        return (
            <a
                className={
                    'product-card ' +
                    this.state.cardStyle +
                    (this.props.comparing ? ' comparison' : '') +
                    (this.state.hover ? ' hover' : '') +
                    (this.props.bundledProduct ? ' bundledProduct' : '')
                }
                href={url}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
            >
                <div className={'content'}>
                    <div className={'sku'}>{this.props.sku}</div>
                    {this.props.comparing ? (
                        <i
                            className="material-icons comparison-remove"
                            onClick={(e) => this.updateComparison(e, this.props.id)}
                        >
                            clear
                        </i>
                    ) : !this.props.hideCompare && this.props.contentType === 'Icecat' ? (
                        <Checkbox
                            className={'comparison-checkbox'}
                            checked={this.state.isInComparison}
                            onChange={(e) => this.updateComparison(e, this.props.id)}
                        >
                            Bera saman
                        </Checkbox>
                    ) : (
                        ''
                    )}
                    {this.props.bundledProduct && this.props.quantityInBundle > 1 ? (
                        <div className="bundle-quantity">{this.props.quantityInBundle} stk.</div>
                    ) : !this.props.specialOrder && !this.props.bundledProduct ? (
                        <QuantityCircle quantity={availableQuantity} maxiumumQuantity={5} />
                    ) : (
                        ''
                    )}
                    <div className={'image-wrapper'}>
                        <img
                            alt={this.props.title}
                            className={'product-image'}
                            src={
                                window.imageBase +
                                changeImageSize(this.props.image, 'big', 'medium')
                            }
                            width={400}
                            height={400}
                            onError={(e) => setDefaultImage(e)}
                        />
                    </div>
                    {!this.props.bundledProduct && this.getPrices()}
                    <span className={'product-title'}>{this.props.title}</span>
                    {!this.props.bundledProduct && this.getButtons(specialOrder)}
                </div>
                {this.props.bannerText ? (
                    <div className={'banner'}>{this.props.bannerText}</div>
                ) : (
                    ''
                )}
                {this.state.insurancesAvailable?.length > 0 ? (
                    <UpsellModal
                        open={this.state.insuranceModalOpen}
                        upsellProducts={this.state.insurancesAvailable}
                        hideModal={this.hideInsuranceModal}
                    />
                ) : (
                    ''
                )}
            </a>
        );
    }
}

export default ProductCard;
